import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { dynaVaultsAPI } from '../../../../api/DynaVaultsAPI';
import { QueryOptions } from 'utils/useQueryUtils';
import { useConnection } from 'wagmi';
import { getStoredTokens } from 'structure/portfolio/utils/portfolio';
import { queryKeys } from 'structure/pv2/vault/configs/queryKeys';
import { useVaultListBlockchain } from 'structure/pv2/dynavault/hooks/useVaultListBlockchain';

export const useVaultList = (options?: QueryOptions) => {
  const { query } = options || {};

  const account = useConnection();
  const tokens = getStoredTokens();
  const authToken = tokens[account.address || ''];

  const useQueryOptions = {
    queryKey: queryKeys.vaultList({
      walletAddress: account.address,
      isAuth: !!authToken,
    }),
    ...query,
  };

  return useQuery({
    placeholderData: keepPreviousData,
    queryFn: () => {
      const tokens = getStoredTokens();
      const authToken = tokens[account.address ?? ''];
      return dynaVaultsAPI.loadVaults(authToken);
    },
    ...useQueryOptions,
  });
};

export const useVaultListWithFallback = (options?: QueryOptions) => {
  const vaultListQuery = useVaultList(options);

  const isApiError =
    vaultListQuery.isFetched &&
    (Boolean(vaultListQuery.data) === false ||
      (vaultListQuery.data?.length ?? 0) === 0);

  const vaultListBlockchainQuery = useVaultListBlockchain({
    ...options,
    chainId: 8453,
    query: {
      enabled: isApiError,
    },
  });

  if (isApiError) {
    return vaultListBlockchainQuery;
  }

  return vaultListQuery;
};
